import { Link } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { ProfilePhotoFallback } from 'src/shared/features/users/components/profile-photos/profile-avatar'
import { expertiseMap } from 'src/shared/features/users/schemas/expertise'
import type { PublicUserData } from 'src/shared/features/users/schemas/user'

import useSearchMenuActiveStore from '../store/search-menu-active-store'

type LynkUserSearchResultItemProps = {
  user: PublicUserData
}

const LynkUserSearchResultItem = ({ user }: LynkUserSearchResultItemProps) => {
  const { setIsFocused } = useSearchMenuActiveStore()
  const imageUrl = user.profilePhoto || undefined
  const expertise = user.expertise?.map((e) => expertiseMap[user.profession]?.[e]?.label).join(', ')

  const onClick = () => {
    setIsFocused(false)
  }

  return (
    <Link onClick={onClick} to={paths.users.profile.getHref(user.username)} state={{ from: 'search' }}>
      <div className="flex max-w-[110px] cursor-pointer flex-col gap-2 overflow-hidden">
        <div className="relative size-[110px] shrink-0 overflow-hidden rounded-[12px]">
          <img
            src={imageUrl || ProfilePhotoFallback}
            alt=""
            className="size-full rounded-[15px] object-cover sm:rounded-none"
          />
        </div>
        <div className="flex flex-col items-start gap-0">
          <p className="line-clamp-1 text-[15px] font-semibold text-primary">
            {[user.firstName, user.lastName?.charAt(0).toUpperCase() + '.'].filter(Boolean).join(' ')}
          </p>
          <p className="line-clamp-1 text-[13px] text-muted">
            {[user.companyName, user.state, expertise]?.filter(Boolean).join(' · ')}
          </p>
        </div>
      </div>
    </Link>
  )
}

export default LynkUserSearchResultItem
